import BridgeV2 from "@akulaku/web-bridge";

import WebSite from "../enums/WebSite";
import AppType from "../enums/AppType";

import isSilvrr from "./isSilvrr";
import getWebSite from "./getWebSite";

const defaultAppName = isSilvrr ? AppType.Silvrr : AppType.Akulaku;
let appName: AppType | null = null;

/**
 * 获取app名称（类型）
 * parseAppInfoByUserAgent 获取的app类型在silvrr上表现错误，返回了akulaku，因此在app内部时需要根据版本来推导app类型
 * @param ctx ctx
 */
export default function getAppName(ctx?: any): AppType {
  // 如果已经获取了appName，直接返回appName
  // 服务端如果传递了ctx，则不能读取缓存，因为服务端缓存不是针对一次访问，而是针对整个服务
  if (!(process.server && ctx) && appName) {
    return appName;
  }
  // 服务端渲染却没有传递ctx则直接抛出错误
  if (process.server && !ctx) {
    // 保证线上页面不会崩溃
    if (process.env.BUILD_ENV === "prod") {
      return defaultAppName;
    }
    throw new Error("server 端调用 getAppName 时必须提供 ctx");
  }
  try {
    // app内部根据bridge获取
    const appInfo = BridgeV2.parseAppInfoByUserAgent(ctx);
    if (appInfo && appInfo.appName) {
      // 根据国家获取app类型，因为 Silvrr 的 appInfo.appName 返回了 akulaku，具体原因是因为原生注入的ua中的app名称不正确
      appName = appInfo.appName === "wisecart" ? AppType.Silvrr : appInfo.appName;
      const versions = (appInfo.version || "").split(".");
      // appName为akulaku，且安卓版本为1.0.x，则是silvrr应用，因为安卓在silvrr此版本appType错误
      if (
        BridgeV2.isAkulakuAndroid(ctx) &&
        versions.length >= 2 &&
        appName === AppType.Akulaku &&
        Number(versions[0]) <= 1 &&
        Number(versions[1]) < 1
      ) {
        appName = AppType.Silvrr;
      }
      return appName as AppType;
    }
    // app外部根据域名判断
    const hostname = process.server ? ctx.req?.hostname : location.hostname;
    const webSite = getWebSite(hostname);

    appName =
      {
        [WebSite.Akulaku]: AppType.Akulaku,
        [WebSite.Silvrrplus]: AppType.Silvrrplus,
        [WebSite.Silvrr]: AppType.Silvrr,
        [WebSite.Wisecart]: AppType.Silvrr,
      }[webSite] || defaultAppName;
  } catch (error) {
    // eslint-disable-next-line
    console.error("get appName error", defaultAppName, error);
    // 执行错误的情况，不给appName设置值，下一次重新计算，当次直接返回 defaultAppName
    appName = null;
    return defaultAppName;
  }

  return appName;
}
